import { selectAnchor } from "../core/utilities";
import OContentModel from "../models/OContentModel";
import UserModel from "../models/UserModel";
import User from "../core/interfaces/User";
import { CCCSelectSingle } from "../components/forms/select-single";
import { Spotlight } from "../core/types/Spotlight";
import CCCSpotlightDialog from "../components/spotlight-dialog/spotlightDialog";
import { enumToSelectItem } from "../core/utilities";
import SelectItem from "../core/interfaces/SelectItem";
import { SpotlightFilter } from "../core/interfaces/ISpotlights";

//components
import "../components/user-avatar/index";
import "../components/spotlight-dialog/spotlightDialog";

export class SpotlightsSinglePageController {
  protected $container: HTMLElement = null;
  protected $dialog: CCCSpotlightDialog = null;
  protected $list: HTMLElement = null;
  protected clickedSpotlight: Spotlight = null;
  $viewSelect: CCCSelectSingle = null;
  viewOptions: Array<SelectItem> = enumToSelectItem(SpotlightFilter);

  async init(anchor: string): Promise<void> {
    this.$container = selectAnchor(anchor);
    if (this.$container) {
      const user: User = await UserModel.getCurrentUserCached();
      this.addHtmlSkeleton(user);
      this.$viewSelect = document.querySelector("#viewSelect");
      this.$viewSelect.setKeyState("options", this.viewOptions);

      const urlParams = new URLSearchParams(window.location.search);
      const isExternal = urlParams.get("oracle") === "true";
      const defaultView = isExternal
        ? this.viewOptions[1]
        : this.viewOptions[0];
      this.$viewSelect.setValue(defaultView);

      this.$viewSelect.onItemSelect((selectedItem: SelectItem) => {
        const newUrl = new URL(window.location.href);
        selectedItem === this.viewOptions[1]
          ? newUrl.searchParams.set("oracle", "true")
          : newUrl.searchParams.delete("oracle");
        window.history.replaceState({}, "", newUrl);
        this.refreshSpotlights(selectedItem);
      });

      this.loadData(defaultView);
    } else {
      console.error(`Spotlights - ${anchor} element not found in DOM`);
    }
  }

  private async refreshSpotlights(filter: SelectItem): Promise<void> {
    this.$list.innerHTML = "";
    await this.loadData(filter);
  }

  private addHtmlSkeleton(user: User | null) {
    this.$container.innerHTML = `
      <ccc-spotlight-dialog class="spotlights-dialog"></ccc-spotlight-dialog>
      <ccc-select-single
        id="viewSelect"
        class="view-select"
        display-as-tabs
        ${user.id ? "" : "hidden"}
      ></ccc-select-single><br />
      <div class="spotlights-list"></div>
      `;

    this.$dialog = <CCCSpotlightDialog>(
      selectAnchor(".spotlights-dialog", this.$container)
    );
    this.$list = selectAnchor(".spotlights-list", this.$container);
  }

  private async loadData(type: SelectItem): Promise<void> {
    let spotlights: Spotlight[] = null;
    if (type == this.viewOptions[1]) {
      spotlights = await OContentModel.getInternalSpotlights();
    } else {
      spotlights = await OContentModel.getSpotlights();
    }

    spotlights.forEach((spotlight) => {
      const $cccUserAvatar = document.createElement("ccc-user-avatar");
      $cccUserAvatar.setAttribute("name", spotlight.authorName);
      $cccUserAvatar.setAttribute("image", spotlight.authorImage);
      $cccUserAvatar.addEventListener("ccc-user-avatar-click", () => {
        this.openDialog(spotlight);
      });

      this.$list.append($cccUserAvatar);
    });
  }

  private openDialog(spotlight: Spotlight): void {
    console.debug("Spotlights - Spotlight:", this.$dialog, spotlight);
    if (
      this.clickedSpotlight === null ||
      spotlight.authorName !== this.clickedSpotlight.authorName
    ) {
      this.clickedSpotlight = spotlight;
      this.$dialog.spotlight = this.clickedSpotlight;
    }
    this.$dialog.open();
  }
}
